module.exports = __webpack_public_path__ + "static/media/pause.6a1fa821.svg";